import React, { useEffect, useState } from "react"
import { useLocationSearch } from "../../../hooks/useLocationSearch"

const LocationSearchInput = ({
  initLocation = { displayName: "" },
  setLocation,
  handleFocus = () => {},
  className = "",
  includeVenues = false,
}) => {
  const [address, setAddress] = useState(initLocation?.displayName || "")
  const [isFocused, setIsFocused] = useState(false)

  // Sync address when initLocation changes (e.g. when form is pre-filled from duplicate)
  useEffect(() => {
    const name = initLocation?.displayName ?? ""
    setAddress(name)
  }, [initLocation?.displayName])

  const { locations, isLoading } = useLocationSearch({
    query: address,
    enabled: address.trim().length > 0,
  })

  // Venue results are opt-in per call site (e.g. a band editing its own
  // address doesn't want bandNada venue name matches showing up) - the
  // endpoint always returns both, so filter client-side.
  const results = includeVenues
    ? locations
    : locations.filter((location) => location.source !== "venue")

  const handleChange = (event) => {
    const value = event.target.value
    setAddress(value)
    if (!value) {
      setLocation({})
    }
  }

  const handleSelect = (location) => {
    setAddress(location.displayName)
    setLocation(location)
  }

  // Don't show dropdown when current value is a confirmed selection (avoids
  // dropdown reappearing after select when parent re-renders and location
  // search returns results for the selected text)
  const hasSelection =
    initLocation?.displayName &&
    (initLocation?.googlePlaceId || initLocation?.venueId) &&
    address.trim() === initLocation.displayName.trim()
  const showDropdown =
    isFocused && !hasSelection && (isLoading || results.length > 0)

  return (
    <div className="relative">
      <input
        type="text"
        value={address}
        onChange={handleChange}
        onFocus={(e) => {
          setIsFocused(true)
          handleFocus(e)
        }}
        onBlur={() => {
          // Delay so click on a suggestion registers before we hide the dropdown
          setTimeout(() => setIsFocused(false), 150)
        }}
        placeholder="Search Places ..."
        className={className}
      />
      <div
        className={`autocomplete-dropdown-container absolute bg-white p-2 z-50 ${
          showDropdown ? "block" : "hidden"
        }`}
      >
        {isLoading && <div>Loading...</div>}

        {results.map((location, index) => (
          <div
            key={location.venueId ?? location.googlePlaceId ?? index}
            className="py-2 cursor-pointer"
            style={{ backgroundColor: "#ffffff", cursor: "pointer" }}
            onClick={() => handleSelect(location)}
          >
            <span
              className={
                location.source === "venue"
                  ? "font-bold text-green-600"
                  : "text-black-800"
              }
            >
              {location.displayName}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LocationSearchInput
